import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import TodayLatestSoldProducts from '@/components/v2/ecommerce/TodayLatestSoldProducts.vue';
import SalesOverview from '@/components/v2/ecommerce/SalesAnalyticsCardWrapper.vue';
import OverviewList from '@/components/v2/ecommerce/OverviewList.vue';
import AnalyticsLayout from '@/views/v2/layouts/ecommerce/Analytics.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { NAV_DRAWER } from '@/helpers/constants/app';
import Avatar from '@/components/avatar/Index.vue';
import TopReferralsQuery from '@/plugins/graphql/queries/v2/ecommerce/ecommerce-overview-products.gql';
import RouterParamsAppMixin from '../../../helpers/vue_mixins/RouterParamsAppMixin';
let Overview = class Overview extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.topReferrals = [];
        this.topReferralsPaginated = false;
        this.lowInventoryProducts = [];
        this.lowInventoryProductsPaginated = false;
    }
    populateReferrals(referrals) {
        const { pageInfo, edges } = referrals;
        this.topReferrals = edges.map(({ node }) => node);
        this.topReferralsPaginated = pageInfo.hasNextPage;
    }
    populateLowInventoryProducts(lowStockQty) {
        const { pageInfo, edges } = lowStockQty;
        this.lowInventoryProducts = edges.map(({ node }) => {
            node.inventoryCount = node.inventoryCount > 0 ? node.inventoryCount : 0;
            return node;
        });
        this.lowInventoryProductsPaginated = pageInfo.hasNextPage;
    }
};
__decorate([
    Mutation('toggleDrawer', { namespace: NAV_DRAWER })
], Overview.prototype, "toggleDrawer", void 0);
Overview = __decorate([
    Component({
        components: {
            AnalyticsLayout,
            SalesOverview,
            OverviewList,
            TodayLatestSoldProducts,
            Avatar,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // Fixes issue on drawer not showing after diy step 4
                if (to.params.key && from.name === 'launch-mini-app') {
                    vm.toggleDrawer(false);
                    setTimeout(() => {
                        vm.toggleDrawer(true);
                    }, 50);
                }
            });
        },
        apollo: {
            overviewLists: {
                query: TopReferralsQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        limit: 5,
                    };
                },
                update({ referrals, lowStockQty }) {
                    this.populateReferrals(referrals);
                    this.populateLowInventoryProducts(lowStockQty);
                },
            },
        },
    })
], Overview);
export default Overview;
